import { PlanStateEnum } from '../../plans/models/PlanModel';
import {
  QuickSaleOrderModel,
  QuickSalePlanModel,
} from '../models/QuickSaleModel';

// Plans the page shows unless the agent asks for the rest.
export const CURRENT_PLAN_STATES: string[] = [
  PlanStateEnum.ACTIVE,
  PlanStateEnum.PROPOSAL,
  PlanStateEnum.REACTIVATING,
  PlanStateEnum.PAYMENT_FAILED,
  PlanStateEnum.NO_PAYMENT_METHOD,
  PlanStateEnum.PAUSED,
  PlanStateEnum.DETAINED,
];
export const CURRENT_FILTER = 'current';
export const ALL_FILTER = 'all';
export const UPCOMING_FILTER = 'upcoming';

export function filterPlans(plans: QuickSalePlanModel[], filter: string) {
  if (filter === CURRENT_FILTER) {
    return plans.filter((plan) => CURRENT_PLAN_STATES.includes(plan.state));
  }
  if (filter === ALL_FILTER) {
    return plans;
  }
  return plans.filter((plan) => plan.state === filter);
}

/** Trial + 2 by default; otherwise every order or those in one state. */
export function visibleOrders(
  plan: QuickSalePlanModel,
  filter: string
): QuickSaleOrderModel[] {
  const { pending, projected, history } = plan.orders;
  if (filter === UPCOMING_FILTER) {
    return [...pending, ...projected];
  }
  if (filter === ALL_FILTER) {
    return [...pending, ...projected, ...history];
  }
  return [...pending, ...history].filter((order) => order.state === filter);
}

/** "Pedido 1" is the first regular order, whether or not there was a trial. */
export function regularNumber(
  plan: QuickSalePlanModel,
  order: QuickSaleOrderModel
): number | null {
  if (!order.position) {
    return null;
  }
  const { pending, history } = plan.orders;
  const hadTrial = [...pending, ...history].some((item) => item.is_trial);
  return hadTrial ? order.position - 1 : order.position;
}
